
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ChZM", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $btHGY = parcelRequire("btHGY");


var $inPa6 = parcelRequire("inPa6");


var $1iSzD = parcelRequire("1iSzD");


var $e4o8D = parcelRequire("e4o8D");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $75Ax4 = parcelRequire("75Ax4");


var $2XV0z = parcelRequire("2XV0z");

const $250035b51418e050$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { isPresenterMode: isPresenterMode, presenterModeHeight: presenterModeHeight, isFullWidthImageOption: isFullWidthImageOption, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isPagePreview: isPagePreview, isObjectHeaderEnabled: isObjectHeaderEnabled, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, objectPosition: objectPosition, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_12lctvr": (0, $7sObp.default)(__cmplp.presenterModeHeight, "px"),
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_z440ka": (0, $7sObp.default)(__cmplp.objectPosition)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_5ral1dfr _1bsb1osq _1e0c1txw _rsuf3crg",
                __cmplp.isPresenterMode ? "_4t3i1w4h" : __cmplp.isFullWidthImageOption ? "_4t3i1a28" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3ifmv9",
                __cmplp.isFixedWidthImageOption && "_1bsb1c3h",
                !__cmplp.isPagePreview && "_19pkpxbi",
                __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : __cmplp.isPagePreview ? "_otyrze3t" : "_otyrxy5q",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
} : ({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isPresenterMode: isPresenterMode, presenterModeHeight: presenterModeHeight, isFullWidthImageOption: isFullWidthImageOption, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isPagePreview: isPagePreview, isObjectHeaderEnabled: isObjectHeaderEnabled, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, objectPosition: objectPosition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12lctvr": (0, $7sObp.default)(__cmplp.presenterModeHeight, "px"),
            "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
            "--_z440ka": (0, $7sObp.default)(__cmplp.objectPosition)
        },
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_5ral1dfr _1bsb1osq _1e0c1txw _rsuf3crg",
            __cmplp.isPresenterMode ? "_4t3i1w4h" : __cmplp.isFullWidthImageOption ? "_4t3i1a28" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3ifmv9",
            __cmplp.isFixedWidthImageOption && "_1bsb1c3h",
            !__cmplp.isPagePreview && "_19pkpxbi",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : __cmplp.isPagePreview ? "_otyrze3t" : "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$export$caf7b844f87776ef = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7izff _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_18u09b24 _p12f1c3h" : "_18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7izff _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_18u09b24 _p12f1c3h" : "_18u09b24",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview ? "_otyrpxbi" : "_otyrxy5q",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$export$e0f0a550d389890d = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isFixedWidthImageOption: isFixedWidthImageOption, isSpaceOverview: isSpaceOverview, isEmbeddedConfluence: isEmbeddedConfluence, hasUnsplashImageLoaded: hasUnsplashImageLoaded, isObjectHeaderEnabled: isObjectHeaderEnabled, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_11q7izff _1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : __cmplp.isSpaceOverview || __cmplp.isEmbeddedConfluence ? "_1bsb1osq" : "_1bsb14oa",
            __cmplp.hasUnsplashImageLoaded ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : "_otyrpxbi",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFixedWidthImageOption: isFixedWidthImageOption, isSpaceOverview: isSpaceOverview, isEmbeddedConfluence: isEmbeddedConfluence, hasUnsplashImageLoaded: hasUnsplashImageLoaded, isObjectHeaderEnabled: isObjectHeaderEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_11q7izff _1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw _19pkpxbi",
            __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
            __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : __cmplp.isSpaceOverview || __cmplp.isEmbeddedConfluence ? "_1bsb1osq" : "_1bsb14oa",
            __cmplp.hasUnsplashImageLoaded ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : "_otyrpxbi",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$var$UnsplashWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((0, $3u0dr.isReactCompilerActiveV1)() ? (t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkon7od _1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_2rkon7od _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $250035b51418e050$var$IdentifierWrapper = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(8);
    const { children: children, isPagePreview: isPagePreview, isEmbeddedConfluence: t1, isFixedWidthImageOption: t2 } = t0;
    const isEmbeddedConfluence = t1 === undefined ? false : t1;
    const isFixedWidthImageOption = t2 === undefined ? false : t2;
    const t3 = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t4;
    if ($[0] !== isEmbeddedConfluence || $[1] !== isFixedWidthImageOption || $[2] !== isPagePreview) {
        t4 = isPagePreview && isFixedWidthImageOption ? {
            display: "flex",
            justifyContent: "center"
        } : !isPagePreview ? isFixedWidthImageOption ? {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px",
            display: isFixedWidthImageOption ? "flex" : "unset",
            justifyContent: isFixedWidthImageOption ? "center" : "unset"
        } : {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px"
        } : {};
        $[0] = isEmbeddedConfluence;
        $[1] = isFixedWidthImageOption;
        $[2] = isPagePreview;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== children || $[5] !== t3 || $[6] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...t3,
            className: "renderer-page-cover-picture",
            style: t4
        }, children);
        $[4] = children;
        $[5] = t3;
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ children: children, isPagePreview: isPagePreview, isEmbeddedConfluence: isEmbeddedConfluence = false, isFixedWidthImageOption: isFixedWidthImageOption = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
        ...(0, $luv00.useSSRPlaceholderReplaceIdProp)(),
        className: "renderer-page-cover-picture",
        style: isPagePreview && isFixedWidthImageOption ? {
            display: 'flex',
            justifyContent: 'center'
        } : !isPagePreview ? isFixedWidthImageOption ? {
            marginLeft: 'var(--full-cover-image-margin, 0px)',
            width: isEmbeddedConfluence ? 'unset' : 'var(--full-cover-image-width, 100%)',
            // need to use non-tokenizable value for marginTop since space.negative.300 (-24px)
            // leaves a small gap between the nav bar and content topper
            marginTop: '-26px',
            display: isFixedWidthImageOption ? 'flex' : 'unset',
            justifyContent: isFixedWidthImageOption ? 'center' : 'unset'
        } : {
            marginLeft: 'var(--full-cover-image-margin, 0px)',
            width: isEmbeddedConfluence ? 'unset' : 'var(--full-cover-image-width, 100%)',
            // need to use non-tokenizable value for marginTop since space.negative.300 (-24px)
            // leaves a small gap between the nav bar and content topper
            marginTop: '-26px'
        } : {}
    }, children);
const $250035b51418e050$var$getPageMode = (isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isLivePageDiffEditor)=>{
    if (isPagePreview) return 'preview';
    else if (isSpaceOverview) return 'space-overview';
    else if (isPresenterMode) return 'presenter';
    else if (isEmbeddedConfluence) return 'embed';
    else if (isLivePageDiffEditor) return 'diff-editor';
    else return 'view';
};
const $250035b51418e050$export$d8da1ed12fdbdfd1 = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(91);
    const { contentId: contentId, isPagePreview: isPagePreview, coverPicture: coverPicture, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, leftRightPaddingValue: leftRightPaddingValue, isPresenterMode: isPresenterMode, coverPictureWidthOverride: coverPictureWidthOverride, isLivePageDiffEditor: isLivePageDiffEditor } = t0;
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    const [hasUnsplashImageLoaded, setHasUnsplashImageLoaded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== contentId || $[1] !== isExternalShare) {
        t1 = {
            contentId: contentId,
            isExternalShare: isExternalShare
        };
        $[0] = contentId;
        $[1] = isExternalShare;
        $[2] = t1;
    } else t1 = $[2];
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)(t1);
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isPageSSRed = isServerPlaceholder || window.__SSR_RENDERED__;
    const isMediaConfigGateReady = isPageSSRed ? !!ssrConfig : !!mediaConfig;
    let t2;
    if ($[3] !== isPageSSRed || $[4] !== mediaConfig || $[5] !== ssrConfig) {
        t2 = isPageSSRed ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[3] = isPageSSRed;
        $[4] = mediaConfig;
        $[5] = ssrConfig;
        $[6] = t2;
    } else t2 = $[6];
    const mediaConfigGated = t2;
    let t3;
    if ($[7] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[7] = contentId;
        $[8] = t3;
    } else t3 = $[8];
    const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t3);
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isFixedWidthImageOption = !isPresenterMode && isFixedWidth;
    const isFullWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const isFullWidthImageOption = !isPresenterMode && isFullWidth;
    const isValidCustomSitesTitleAlignment = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER || titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).LEFT;
    const titleAlignment = isValidCustomSitesTitleAlignment && titleContentProperties && titleContentProperties.titleLayoutAlignment ? titleContentProperties.titleLayoutAlignment : "";
    const leftRightPaddingValueOffset = isPagePreview && leftRightPaddingValue ? leftRightPaddingValue : 0;
    const { height: height } = (0, $2XV0z.usePageHeightWidthObserver)(isPagePreview, leftRightPaddingValueOffset, isPresenterMode);
    const dynamicHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : height;
    const imageId = (isPagePreview || isLivePageDiffEditor ? coverPicture.draft?.value.id : coverPicture.published?.value.id) || "";
    const position = (isPagePreview || isLivePageDiffEditor ? coverPicture.draft?.value.position : coverPicture.published?.value.position) || "";
    const objectPosition = `center ${position}%`;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    if ($[9] !== imageId) {
        t4 = !!imageId && imageId.includes("images.unsplash.com");
        $[9] = imageId;
        $[10] = t4;
    } else t4 = $[10];
    const isUnsplashCoverImage = t4;
    const currentPageMode = $250035b51418e050$var$getPageMode(isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isLivePageDiffEditor);
    let t5;
    if ($[11] !== createAnalyticsEvent) {
        t5 = (isUnsplash, appearance_0, pageMode, pageTitleAlignment, isFixedWidthCoverImage)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "viewed",
                    actionSubject: "HeaderImage",
                    actionSubjectId: "viewPageHeaderImage",
                    source: "viewPageHeaderImage",
                    attributes: {
                        headerImageType: isUnsplash ? "unsplash" : "user-uploaded",
                        contentAppearance: appearance_0,
                        pageMode: pageMode,
                        pageTitleAlignment: pageTitleAlignment,
                        coverImageWidth: isFixedWidthCoverImage ? "fixed-width" : "full-width"
                    }
                }
            }).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const createViewHeaderImageAnalyticsEvent = t5;
    let t6;
    let t7;
    if ($[13] !== appearance || $[14] !== createViewHeaderImageAnalyticsEvent || $[15] !== currentPageMode || $[16] !== isFixedWidthImageOption || $[17] !== isUnsplashCoverImage || $[18] !== titleAlignment) {
        t6 = ()=>{
            createViewHeaderImageAnalyticsEvent(isUnsplashCoverImage, appearance, currentPageMode, titleAlignment, isFixedWidthImageOption);
        };
        t7 = [
            isUnsplashCoverImage,
            appearance,
            currentPageMode,
            titleAlignment,
            isFixedWidthImageOption,
            createViewHeaderImageAnalyticsEvent
        ];
        $[13] = appearance;
        $[14] = createViewHeaderImageAnalyticsEvent;
        $[15] = currentPageMode;
        $[16] = isFixedWidthImageOption;
        $[17] = isUnsplashCoverImage;
        $[18] = titleAlignment;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[21] !== contentId || $[22] !== isExternalShare || $[23] !== setMediaConfig) {
        t8 = ()=>{
            if ((0, $9wGTI.fg)("confluence_frontend_view_page_cover_image_fix")) {
                let isMounted = true;
                setMediaConfig(null);
                (0, $4IoVL.createRendererMediaProvider)({
                    contentId: contentId,
                    isExternalShare: isExternalShare
                }).then((t9)=>{
                    const { viewMediaClientConfig: viewMediaClientConfig } = t9;
                    if (isMounted) setMediaConfig({
                        collection: `contentId-${contentId}`,
                        authProvider: viewMediaClientConfig.authProvider
                    });
                });
                return ()=>{
                    isMounted = false;
                };
            } else (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                isExternalShare: isExternalShare
            }).then((t10)=>{
                const { viewMediaClientConfig: viewMediaClientConfig_0 } = t10;
                setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig_0.authProvider
                });
            });
        };
        $[21] = contentId;
        $[22] = isExternalShare;
        $[23] = setMediaConfig;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== contentId || $[26] !== isExternalShare) {
        t9 = [
            contentId,
            isExternalShare
        ];
        $[25] = contentId;
        $[26] = isExternalShare;
        $[27] = t9;
    } else t9 = $[27];
    (0, $42omo.useEffect)(t8, t9);
    if (!isMediaConfigGateReady || !imageId && !isUnsplashCoverImage) {
        let t10;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== isFixedWidthImageOption || $[30] !== isPagePreview || $[31] !== isSpaceOverview) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                isPagePreview: isPagePreview,
                isSpaceOverview: isSpaceOverview,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isObjectHeaderEnabled: t10
            });
            $[29] = isFixedWidthImageOption;
            $[30] = isPagePreview;
            $[31] = isSpaceOverview;
            $[32] = t11;
        } else t11 = $[32];
        let t12;
        if ($[33] !== isEmbeddedConfluence || $[34] !== isFixedWidthImageOption || $[35] !== isPagePreview || $[36] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption
            }, t11);
            $[33] = isEmbeddedConfluence;
            $[34] = isFixedWidthImageOption;
            $[35] = isPagePreview;
            $[36] = t11;
            $[37] = t12;
        } else t12 = $[37];
        return t12;
    }
    if (isUnsplashCoverImage) {
        let t10;
        if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[38] = t10;
        } else t10 = $[38];
        let t11;
        if ($[39] !== hasUnsplashImageLoaded || $[40] !== isEmbeddedConfluence || $[41] !== isFixedWidthImageOption || $[42] !== isPagePreview || $[43] !== isSpaceOverview) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$e0f0a550d389890d, {
                isPagePreview: isPagePreview,
                hasUnsplashImageLoaded: hasUnsplashImageLoaded,
                isSpaceOverview: isSpaceOverview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isObjectHeaderEnabled: t10
            });
            $[39] = hasUnsplashImageLoaded;
            $[40] = isEmbeddedConfluence;
            $[41] = isFixedWidthImageOption;
            $[42] = isPagePreview;
            $[43] = isSpaceOverview;
            $[44] = t11;
        } else t11 = $[44];
        let t12;
        if ($[45] !== setHasUnsplashImageLoaded) {
            t12 = ()=>{
                setHasUnsplashImageLoaded(true);
            };
            $[45] = setHasUnsplashImageLoaded;
            $[46] = t12;
        } else t12 = $[46];
        let t13;
        if ($[47] !== dynamicHeight || $[48] !== isPresenterMode) {
            t13 = !(0, $6mKj3.expVal)("confluence_frontend_fix_cover_image_class_change", "isEnabled", false) || isPresenterMode ? dynamicHeight : undefined;
            $[47] = dynamicHeight;
            $[48] = isPresenterMode;
            $[49] = t13;
        } else t13 = $[49];
        let t14;
        if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[50] = t14;
        } else t14 = $[50];
        let t15;
        if ($[51] !== hasEmoji || $[52] !== imageId || $[53] !== isFixedWidthImageOption || $[54] !== isFullWidthImageOption || $[55] !== isPagePreview || $[56] !== isPresenterMode || $[57] !== isSpaceOverview || $[58] !== objectPosition || $[59] !== t12 || $[60] !== t13) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                "data-testid": "unsplash-cover-picture",
                "data-vc": "unsplash-cover-picture-renderer",
                alt: "",
                isPagePreview: isPagePreview,
                src: imageId,
                objectPosition: objectPosition,
                onLoad: t12,
                isSpaceOverview: isSpaceOverview,
                hasEmoji: hasEmoji,
                dynamicCoverImageHeight: undefined,
                presenterModeHeight: t13,
                isPresenterMode: isPresenterMode,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isFullWidthImageOption: isFullWidthImageOption,
                isObjectHeaderEnabled: t14
            });
            $[51] = hasEmoji;
            $[52] = imageId;
            $[53] = isFixedWidthImageOption;
            $[54] = isFullWidthImageOption;
            $[55] = isPagePreview;
            $[56] = isPresenterMode;
            $[57] = isSpaceOverview;
            $[58] = objectPosition;
            $[59] = t12;
            $[60] = t13;
            $[61] = t15;
        } else t15 = $[61];
        let t16;
        if ($[62] !== imageId || $[63] !== t11 || $[64] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$UnsplashWrapper, {
                key: imageId
            }, t11, t15);
            $[62] = imageId;
            $[63] = t11;
            $[64] = t15;
            $[65] = t16;
        } else t16 = $[65];
        let t17;
        if ($[66] !== isEmbeddedConfluence || $[67] !== isFixedWidthImageOption || $[68] !== isPagePreview || $[69] !== t16) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption
            }, t16);
            $[66] = isEmbeddedConfluence;
            $[67] = isFixedWidthImageOption;
            $[68] = isPagePreview;
            $[69] = t16;
            $[70] = t17;
        } else t17 = $[70];
        return t17;
    } else if (isMediaConfigGateReady && mediaConfigGated) {
        const t10 = isPageSSRed ? `contentId-${contentId}` : mediaConfig?.collection;
        let t11;
        if ($[71] !== imageId || $[72] !== t10) {
            t11 = {
                mediaItemType: "file",
                id: imageId,
                collectionName: t10
            };
            $[71] = imageId;
            $[72] = t10;
            $[73] = t11;
        } else t11 = $[73];
        let t12;
        if ($[74] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[74] = t12;
        } else t12 = $[74];
        const t13 = isPageSSRed ? ssrConfig?.mode : undefined;
        let t14;
        if ($[75] !== dynamicHeight || $[76] !== hasEmoji || $[77] !== isEmbeddedConfluence || $[78] !== isFixedWidthImageOption || $[79] !== isFullWidthImageOption || $[80] !== isPagePreview || $[81] !== isPresenterMode || $[82] !== isSpaceOverview || $[83] !== objectPosition) {
            t14 = (t15)=>{
                const { data: data, loading: loading } = t15;
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                    isPagePreview: isPagePreview,
                    isSpaceOverview: isSpaceOverview,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                }));
                if (!data) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                    isPagePreview: isPagePreview,
                    src: data.src,
                    objectPosition: objectPosition,
                    isSpaceOverview: isSpaceOverview,
                    hasEmoji: hasEmoji,
                    dynamicCoverImageHeight: undefined,
                    presenterModeHeight: !(0, $6mKj3.expVal)("confluence_frontend_fix_cover_image_class_change", "isEnabled", false) || isPresenterMode ? dynamicHeight : undefined,
                    isPresenterMode: isPresenterMode,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isFullWidthImageOption: isFullWidthImageOption,
                    isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                    alt: ""
                }));
            };
            $[75] = dynamicHeight;
            $[76] = hasEmoji;
            $[77] = isEmbeddedConfluence;
            $[78] = isFixedWidthImageOption;
            $[79] = isFullWidthImageOption;
            $[80] = isPagePreview;
            $[81] = isPresenterMode;
            $[82] = isSpaceOverview;
            $[83] = objectPosition;
            $[84] = t14;
        } else t14 = $[84];
        let t15;
        if ($[85] !== imageId || $[86] !== mediaConfigGated || $[87] !== t11 || $[88] !== t13 || $[89] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
                key: imageId,
                identifier: t11,
                mediaClientConfig: mediaConfigGated,
                apiConfig: t12,
                ssr: t13
            }, t14);
            $[85] = imageId;
            $[86] = mediaConfigGated;
            $[87] = t11;
            $[88] = t13;
            $[89] = t14;
            $[90] = t15;
        } else t15 = $[90];
        return t15;
    }
} : ({ contentId: contentId, isPagePreview: isPagePreview, coverPicture: coverPicture, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, leftRightPaddingValue: leftRightPaddingValue, isPresenterMode: isPresenterMode, coverPictureWidthOverride: coverPictureWidthOverride, isLivePageDiffEditor: isLivePageDiffEditor })=>{
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    const [hasUnsplashImageLoaded, setHasUnsplashImageLoaded] = (0, $42omo.useState)(false);
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)({
        contentId: contentId,
        isExternalShare: isExternalShare
    });
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isPageSSRed = isServerPlaceholder || window.__SSR_RENDERED__;
    const isMediaConfigGateReady = isPageSSRed ? !!ssrConfig : !!mediaConfig;
    const mediaConfigGated = isPageSSRed ? ssrConfig && ssrConfig.config : mediaConfig && {
        authProvider: mediaConfig.authProvider
    };
    const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)({
        contentId: contentId
    });
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isFixedWidthImageOption = !isPresenterMode && isFixedWidth;
    const isFullWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const isFullWidthImageOption = !isPresenterMode && isFullWidth;
    const isValidCustomSitesTitleAlignment = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER || titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).LEFT;
    const titleAlignment = isValidCustomSitesTitleAlignment && titleContentProperties && titleContentProperties.titleLayoutAlignment ? titleContentProperties.titleLayoutAlignment : '';
    const leftRightPaddingValueOffset = isPagePreview && leftRightPaddingValue ? leftRightPaddingValue : 0;
    const { height: height } = (0, $2XV0z.usePageHeightWidthObserver)(isPagePreview, leftRightPaddingValueOffset, isPresenterMode);
    const dynamicHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : height; // if we are in page preview, we need to show the draft image/position/appearance since we are in edit mode
    // If we are rendered via diff editor and live page, we need to show the draft image/position/appearance since live pages store their cover picture in draft
    const imageId = (isPagePreview || isLivePageDiffEditor ? coverPicture.draft?.value.id : coverPicture.published?.value.id) || '';
    const position = (isPagePreview || isLivePageDiffEditor ? coverPicture.draft?.value.position : coverPicture.published?.value.position) || '';
    const objectPosition = `center ${position}%`;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)(); // using imageId as key since the query gets outdated information and we need to force a re-render after it gets the
    // correct info
    const isUnsplashCoverImage = !!imageId && imageId.includes('images.unsplash.com');
    const currentPageMode = $250035b51418e050$var$getPageMode(isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isLivePageDiffEditor);
    const createViewHeaderImageAnalyticsEvent = (0, $42omo.useCallback)((isUnsplash, appearance_0, pageMode, pageTitleAlignment, isFixedWidthCoverImage)=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'viewed',
                actionSubject: 'HeaderImage',
                actionSubjectId: 'viewPageHeaderImage',
                source: 'viewPageHeaderImage',
                attributes: {
                    headerImageType: isUnsplash ? 'unsplash' : 'user-uploaded',
                    contentAppearance: appearance_0,
                    pageMode: pageMode,
                    pageTitleAlignment: pageTitleAlignment,
                    coverImageWidth: isFixedWidthCoverImage ? 'fixed-width' : 'full-width'
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    (0, $42omo.useEffect)(()=>{
        createViewHeaderImageAnalyticsEvent(isUnsplashCoverImage, appearance, currentPageMode, titleAlignment, isFixedWidthImageOption);
    }, [
        isUnsplashCoverImage,
        appearance,
        currentPageMode,
        titleAlignment,
        isFixedWidthImageOption,
        createViewHeaderImageAnalyticsEvent
    ]); // Setup media config
    (0, $42omo.useEffect)(()=>{
        if ((0, $9wGTI.fg)('confluence_frontend_view_page_cover_image_fix')) {
            let isMounted = true;
            setMediaConfig(null);
            (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                isExternalShare: isExternalShare
            }).then(({ viewMediaClientConfig: viewMediaClientConfig })=>{
                if (isMounted) setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            });
            return ()=>{
                isMounted = false;
            };
        } else (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            isExternalShare: isExternalShare
        }).then(({ viewMediaClientConfig: viewMediaClientConfig_0 })=>{
            setMediaConfig({
                collection: `contentId-${contentId}`,
                authProvider: viewMediaClientConfig_0.authProvider
            });
        });
    }, [
        contentId,
        isExternalShare
    ]); // return placeholder if there is a custom upload
    if (!isMediaConfigGateReady || !imageId && !isUnsplashCoverImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
        isPagePreview: isPagePreview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
        isPagePreview: isPagePreview,
        isSpaceOverview: isSpaceOverview,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    }));
    if (isUnsplashCoverImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
        isPagePreview: isPagePreview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$UnsplashWrapper, {
        key: imageId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$e0f0a550d389890d, {
        isPagePreview: isPagePreview,
        hasUnsplashImageLoaded: hasUnsplashImageLoaded,
        isSpaceOverview: isSpaceOverview,
        isEmbeddedConfluence: isEmbeddedConfluence,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
        "data-testid": "unsplash-cover-picture",
        "data-vc": "unsplash-cover-picture-renderer" // need this empty alt tag for decorative images
        ,
        alt: "",
        isPagePreview: isPagePreview,
        src: imageId,
        objectPosition: objectPosition,
        onLoad: ()=>{
            setHasUnsplashImageLoaded(true);
        },
        isSpaceOverview: isSpaceOverview,
        hasEmoji: hasEmoji,
        dynamicCoverImageHeight: undefined,
        presenterModeHeight: !(0, $6mKj3.expVal)('confluence_frontend_fix_cover_image_class_change', 'isEnabled', false) || isPresenterMode ? dynamicHeight : undefined,
        isPresenterMode: isPresenterMode,
        isFixedWidthImageOption: isFixedWidthImageOption,
        isFullWidthImageOption: isFullWidthImageOption,
        isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
    })));
    else if (isMediaConfigGateReady && mediaConfigGated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
        key: imageId,
        identifier: {
            mediaItemType: 'file',
            id: imageId,
            collectionName: isPageSSRed ? `contentId-${contentId}` : mediaConfig?.collection
        },
        mediaClientConfig: mediaConfigGated,
        apiConfig: {
            allowAnimated: true,
            mode: 'full-fit',
            upscale: false
        },
        ssr: isPageSSRed ? ssrConfig?.mode : undefined
    }, ({ data: data, loading: loading })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
            isPagePreview: isPagePreview,
            isEmbeddedConfluence: isEmbeddedConfluence,
            isFixedWidthImageOption: isFixedWidthImageOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
            isPagePreview: isPagePreview,
            isSpaceOverview: isSpaceOverview,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper')
        }));
        if (!data) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
            isPagePreview: isPagePreview,
            isEmbeddedConfluence: isEmbeddedConfluence,
            isFixedWidthImageOption: isFixedWidthImageOption
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
            isPagePreview: isPagePreview,
            src: data.src,
            objectPosition: objectPosition,
            isSpaceOverview: isSpaceOverview,
            hasEmoji: hasEmoji,
            dynamicCoverImageHeight: undefined,
            presenterModeHeight: !(0, $6mKj3.expVal)('confluence_frontend_fix_cover_image_class_change', 'isEnabled', false) || isPresenterMode ? dynamicHeight : undefined,
            isPresenterMode: isPresenterMode,
            isFixedWidthImageOption: isFixedWidthImageOption,
            isFullWidthImageOption: isFullWidthImageOption,
            isObjectHeaderEnabled: (0, $9wGTI.fg)('confluence_frontend_content_wrapper'),
            alt: ""
        }));
    });
};
const $250035b51418e050$export$60620c3d63f5f30 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($250035b51418e050$export$d8da1ed12fdbdfd1);
module.exports["ImageWrapper"] = $250035b51418e050$export$75f07c36086c2c81;
module.exports["LoadingDiv"] = $250035b51418e050$export$caf7b844f87776ef;
module.exports["UnsplashLoadingDiv"] = $250035b51418e050$export$e0f0a550d389890d;
module.exports["RendererPageCoverPictureComponent"] = $250035b51418e050$export$d8da1ed12fdbdfd1;
module.exports["RendererPageCoverPicture"] = $250035b51418e050$export$60620c3d63f5f30;

});

parcelRegister("btHGY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $fKV6c = parcelRequire("fKV6c");

const $9af2e217c87bad78$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fKV6c.MediaImageWithMediaClient), {
            ...props
        })
    });
module.exports["MediaImageWithErrorBoundary"] = $9af2e217c87bad78$export$758a2fef95a29ad0;

});

parcelRegister("lAJUP", function(module, exports) {

var $42omo = parcelRequire("42omo");

'use client';
const $fb8093ab2fb0a0e7$export$b16d9fb1a22de840 = (0, $42omo.createContext)(null);
const $fb8093ab2fb0a0e7$var$initialState = {
    didCatch: false,
    error: null
};
class $fb8093ab2fb0a0e7$export$e926676385687eaf extends (0, $42omo.Component) {
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $fb8093ab2fb0a0e7$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($fb8093ab2fb0a0e7$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $42omo.createElement)(FallbackComponent, props);
            else if (fallback === null || (0, $42omo.isValidElement)(fallback)) childToRender = fallback;
            else throw error;
        }
        return (0, $42omo.createElement)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $fb8093ab2fb0a0e7$var$initialState;
    }
}
function $fb8093ab2fb0a0e7$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $fb8093ab2fb0a0e7$export$c052f6604b7d51fe() {
    const context = (0, $42omo.useContext)($fb8093ab2fb0a0e7$export$b16d9fb1a22de840);
    $fb8093ab2fb0a0e7$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $42omo.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $42omo.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $42omo.forwardRef)((props, ref)=>(0, $42omo.createElement)($fb8093ab2fb0a0e7$export$e926676385687eaf, errorBoundaryProps, (0, $42omo.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}
module.exports["ErrorBoundary"] = $fb8093ab2fb0a0e7$export$e926676385687eaf;
module.exports["withErrorBoundary"] = $fb8093ab2fb0a0e7$export$f0c7a449e0cfaec7;

});

parcelRegister("fKV6c", function(module, exports) {
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $7soXU = parcelRequire("7soXU");


var $k0QVR = parcelRequire("k0QVR");


var $dh538 = parcelRequire("dh538");

const $30e6950c7927d39d$var$copyDivStyles = null;
const $30e6950c7927d39d$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $k0QVR.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $dh538.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $gMc0m.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $l998X.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $30e6950c7927d39d$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $42omo.useMemo)(()=>(0, $7soXU.withMediaClient)($30e6950c7927d39d$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $l998X.jsx)(MediaImageComponent, {
        ...props
    });
};
module.exports["MediaImageWithMediaClient"] = $30e6950c7927d39d$export$8acd7eecc88dfeb5;

});

parcelRegister("7soXU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");


var $grxv4 = parcelRequire("grxv4");


var $3rvSa = parcelRequire("3rvSa");

const $9f89bc087ab3777e$export$9f7977d4a2561bee = (Component)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)('media-perf-uplift-mutation-fix'), ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>{
        const existingMediaClient = (0, $42omo.useContext)((0, $3rvSa.MediaClientContext));
        const mediaClient = (0, $42omo.useMemo)(()=>existingMediaClient ?? (0, $grxv4.getMediaClient)(mediaClientConfig), [
            mediaClientConfig,
            existingMediaClient
        ]);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Provider, {
            value: mediaClient,
            children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                ...otherProps,
                mediaClient: mediaClient
            })
        });
    }, ({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3rvSa.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        }));
module.exports["withMediaClient"] = $9f89bc087ab3777e$export$9f7977d4a2561bee;

});

parcelRegister("9JpPs", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");

function $c712b10e1cbb5738$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $42omo.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, $l998X.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}
module.exports["componentWithCondition"] = $c712b10e1cbb5738$export$6e8ea24b15199873;

});

parcelRegister("e4o8D", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

const $2679ebd914f0a083$export$96e8e9e8e57310bb = (0, $3u0dr.isReactCompilerActiveV1)() ? (t0)=>{
    const $ = (0, $frIzR.c)(2);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    return renderServerPlaceholder;
} : (renderServerPlaceholderOnNonHydrate = false)=>{
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    !isTransition || Boolean(undefined) : // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    (0, $42omo.useEffect)(()=>{
        setRenderServerPlaceholder(false);
    }, []);
    return renderServerPlaceholder;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("luv00", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2XV0z", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (0, $3u0dr.isReactCompilerActiveV1)() ? (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $frIzR.c)(9);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $42omo.useState)(0);
    const observerRef = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const [height, setHeight] = (0, $42omo.useState)(0);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $42omo.useState)(0);
    const observerRef = (0, $42omo.useRef)(null);
    (0, $42omo.useEffect)(()=>{
        let queryId;
        if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
        else if (isPagePreview) queryId = "[id='header-row-wrapper']";
        else queryId = '.content-screen-component';
        const pageScrollParent = document.querySelector(queryId);
        if (pageScrollParent) {
            observerRef.current = new ResizeObserver((entries)=>{
                // webkitbrowsers add a scroll padding that pushes content around
                if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                    const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                    const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                    if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                }
                const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                setWidth(currentWidth);
                setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
            });
            observerRef.current.observe(pageScrollParent);
            return ()=>observerRef?.current?.disconnect();
        }
    }, [
        observerRef,
        leftOffset,
        isPagePreview,
        leftRightPaddingValueOffset,
        isPresenterMode
    ]);
    return {
        height: height,
        width: width
    };
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("cQbj1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $95931c783b128167$var$_react = $95931c783b128167$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $95931c783b128167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $95931c783b128167$var$Presentation24Icon = (props)=>/*#__PURE__*/ $95931c783b128167$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$95931c783b128167$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $95931c783b128167$var$_default = module.exports.default = $95931c783b128167$var$Presentation24Icon;

});

parcelRegister("iFCP2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d97a2b9af590931e$var$_react = $d97a2b9af590931e$var$_interopRequireDefault((parcelRequire("42omo")));

var $id7ja = parcelRequire("id7ja");

function $d97a2b9af590931e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d97a2b9af590931e$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $d97a2b9af590931e$var$_react.default.createElement($id7ja.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d97a2b9af590931e$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $d97a2b9af590931e$var$_default = module.exports.default = $d97a2b9af590931e$var$Spreadsheet24Icon;

});

parcelRegister("bedQP", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $9JpPs = parcelRequire("9JpPs");

const $9aeacd26f36a9957$export$cf56d0f54cfcce4 = (featureFlagName, ComponentTrue, ComponentFalse)=>(0, $9JpPs.componentWithCondition)(()=>(0, $dh538.fg)(featureFlagName), ComponentTrue, ComponentFalse);
module.exports["componentWithFG"] = $9aeacd26f36a9957$export$cf56d0f54cfcce4;

});

parcelRegister("9k33u", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $l998X.jsx)($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("4GGNn", function(module, exports) {

var $GLgaM = parcelRequire("GLgaM");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError }) {
    const json = await (0, $GLgaM.fetchResponse)({
        url: url,
        method: method,
        body: body,
        headers: headers,
        credentials: credentials,
        parseResponseOnSuccess: parseResponseOnSuccess,
        parseResponseOnError: parseResponseOnError
    }, variables);
    const data = await parseResult(json, variables);
    return {
        data: data
    };
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("8WQTF", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $4677820b18a14e4d$export$66feffbad722f9d4 = /*#__PURE__*/ (0, $42omo.createContext)({
    rendererActions: null,
    pageId: undefined,
    pageAdf: undefined
});
$4677820b18a14e4d$export$66feffbad722f9d4.displayName = 'RendererActionsContext';
const $4677820b18a14e4d$export$c7c5640cf8aff722 = /*#__PURE__*/ (0, $42omo.createContext)({
    setRendererActions: ()=>{},
    setPageAdf: ()=>{}
});
$4677820b18a14e4d$export$c7c5640cf8aff722.displayName = 'RendererActionsDispatchContext';
const $4677820b18a14e4d$export$a41bfe8d4028fb59 = ({ children: children })=>{
    const [rendererActions, setRendererActions] = (0, $42omo.useState)(null);
    const [pageId, setPageId] = (0, $42omo.useState)(undefined);
    const [pageAdf, setPageAdf] = (0, $42omo.useState)(undefined);
    const providerValue = (0, $42omo.useMemo)(()=>({
            rendererActions: rendererActions,
            pageId: pageId,
            pageAdf: pageAdf
        }), [
        rendererActions,
        pageId,
        pageAdf
    ]);
    const dispatchProviderValue = (0, $42omo.useMemo)(()=>({
            setRendererActions: (actions, newPageId)=>{
                setRendererActions(actions);
                setPageId(newPageId);
            },
            setPageAdf: (newPageAdf)=>{
                setPageAdf(newPageAdf);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$66feffbad722f9d4.Provider, {
        value: providerValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($4677820b18a14e4d$export$c7c5640cf8aff722.Provider, {
        value: dispatchProviderValue
    }, children));
};
const $4677820b18a14e4d$export$55249bdd00e8a5d6 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$66feffbad722f9d4);
};
const $4677820b18a14e4d$export$6e9863dfedeaae60 = ()=>{
    return (0, $42omo.useContext)($4677820b18a14e4d$export$c7c5640cf8aff722);
};
module.exports["RendererActionsProvider"] = $4677820b18a14e4d$export$a41bfe8d4028fb59;
module.exports["useRendererActions"] = $4677820b18a14e4d$export$55249bdd00e8a5d6;
module.exports["useRendererActionsDispatch"] = $4677820b18a14e4d$export$6e9863dfedeaae60;

});


//# sourceMappingURL=RendererPageCoverPicture.651e8d3f.js.map
